/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { Map, TileLayer, Marker } from 'react-leaflet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faCamera } from '@fortawesome/free-solid-svg-icons';
import L from 'leaflet';
import Async from 'react-select/async';
import moment from 'moment';
import CSS from './add-load-styles';
import { getSessionUserData } from '../../../libs/user';
import HumberInput from '../../Global';
import HumberDropdown from './components/humber-dropdown';
import SelectionButton from './components/SelectionButton';
import startIcon from '../../../img/StartIcon';
import endIcon from '../../../img/EndIcon';
import client from '../../../api/api';
import Loading from '../../../libs/loading/index';
import OptionsRedirect from '../../OptionsRedirect/OptionsRedirect';
import AddLoadForm from '../../Kyc/AddLoadForm';
import config from '../../../api/config';
// import VirreyesAddLoadForm from '../../Virreyes/AddLoadForm';

const loadOriginOption = [
  { value: 'Cosecha', id: 'Cosecha' },
  { value: 'Bolson', id: 'Bolson' },
  { value: 'Silos', id: 'Silos' },
  { value: 'Otros', id: 'Otros' },
];

const publicationTimeArr = [
  { value: 'por 2 Hs', id: 2 },
  { value: 'por 4 Hs', id: 4 },
  { value: 'por 8 Hs', id: 8 },
];

const TODAY_STRING = '(Hoy)';
const ALL_FIELD_COMPLETED_ERR_MSG = 'Todos los campos con * deben estar completos';

const AddLoadView = props => {
  const { cuit, _id } = getSessionUserData().data;

  const mapState = { lat: -36.0, lng: -64.0 };
  const initialMarker = L.latLng(-38.0, -57.55);
  const destinationMarker = L.latLng(-31.53, -68.53);
  const initialbounds = L.latLngBounds(initialMarker, destinationMarker);
  const initialPosition = [mapState.lat, mapState.lng];
  const bounds = initialbounds;

  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setERRORMsg] = useState('');
  const [stepOne, setStepOne] = useState(true);
  const [position, setPosition] = useState(initialPosition);
  const [renderFromMarker, setRenderFromMarker] = useState(false);
  const [fromMarkerPosition, setFromMarkerPosition] = useState('');
  const [renderToMarker, setRenderToMarker] = useState(false);
  const [toMarkerPosition, setToMarkerPosition] = useState('');
  const [fromId, setFromId] = useState('');
  const [fromCity, setFromCity] = useState('');
  const [fromAddress, setFromAddress] = useState('');
  const [from, setFrom] = useState('');
  const [fromDepartment, setFromDepartment] = useState('');
  const [fromProvince, setFromProvince] = useState('');
  const [fromCountryId, setFromCountryId] = useState(undefined);
  const [fromGeoCodeStr, setFromGeoCodeStr] = useState('');
  const [toId, setToId] = useState('');
  const [toCity, setToCity] = useState('');
  const [toAddress, setToAddress] = useState('');
  const [to, setTo] = useState('');
  const [toDepartment, setToDepartment] = useState('');
  const [toProvince, setToProvince] = useState('');
  const [toCountryId, setToCountryId] = useState(undefined);
  const [toGeoCodeStr, setToGeoCodeStr] = useState('');
  const [plusKmFrom, setPlusKmFrom] = useState('');
  const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
  const [plusKmTo, setPlusKmTo] = useState('');
  const [distance, setDistance] = useState(0);
  const [loadTypes, setLoadTypes] = useState('');
  const [loadTypeSelected, setLoadTypeSelected] = useState('');
  const [productTypes, setProductTypes] = useState([]);
  const [productTypeSelected, setProductTypeSelected] = useState('');
  const [units, setUnits] = useState('');
  const [loadOrigin, setLoadOrigin] = useState('');
  const [requestedTrucks, setRequestedTrucks] = useState('');
  const [productQuantity, setProductQuantity] = useState('');
  const [unitSelected, setUnitSelected] = useState('');
  const [loadDate, setLoadDate] = useState('');
  const [hour, setHour] = useState('');
  const [publicComments, setPublicComments] = useState('');
  const [privateComments, setPrivateComments] = useState('');
  const [flatImage, setFlatImage] = useState('');
  const [flatImageUri, setFlatImageUri] = useState('');
  const [publicationTime, setPublicationTime] = useState('');
  const [truckerSelectedList, setTruckerSelectedList] = useState([]);
  const [trucker, setTrucker] = useState('');
  const [manualFare, setManualFare] = useState(0);
  const [fare, setFare] = useState('');
  const [fareType, setFareType] = useState('');
  const [insured, setInsured] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [resetFields, setResetFields] = useState(false);
  const [avtiveLoadsRedirect, setActiveLoadsRedirect] = useState(false);
  const [countries, setCountries] = useState([]);

  const { RIZOBACTER_CUITS /* , VIRREYES_CUITS */ } = config;
  const [isRizobacterPoint, setIsRizobacterPoint] = useState(false);
  // const [isVireyesPoint, setIsVireyesPoint] = useState(false);
  // const [user, setUser] = useState(null);
  const [shipperDetailId, setShipperDetailId] = useState(undefined);

  const {
    endpoints: { shipper, generic },
  } = client;

  useEffect(() => {
    if (cuit) {
      setIsRizobacterPoint(RIZOBACTER_CUITS.includes(cuit));
    }
  }, [cuit]);

  async function getShipperById(id) {
    setIsLoading(true);

    const { data } = await shipper.getShipperById(id);

    setShipperDetailId(data?.id);

    // if (data?.user?.cuit === VIRREYES_CUITS) {
    //   setIsVireyesPoint(true);
    //   data.user.zone = data.zone;
    //   setUser(data?.user);
    // }

    setIsLoading(false);
  }

  async function getCountries() {
    const { data } = await shipper.getCountries();
    setCountries(data);
  }

  async function getLoadTypes() {
    const { data } = await shipper.getProducts();
    setLoadTypes(data);
  }

  async function getUnits() {
    const { data } = await shipper.getUnits();
    // eslint-disable-next-line no-shadow
    setUnits(data.map(({ id: _id, name: label }) => ({ _id, label })));
  }

  const originOptions = async inputValue => {
    if (inputValue) {
      try {
        const { data } = await shipper.getPlacesSearch(inputValue);
        return data;
      } catch (e) {
        console.error(e);
      }
    }
    return null;
  };

  const destinationOptions = async inputValue => {
    if (inputValue) {
      try {
        const { data } = await shipper.getPlacesSearch(inputValue);
        return data;
      } catch (error) {
        console.error(error);
      }
    }
    return null;
  };

  const getPlaceDetails = async (placeId, flag) => {
    if (placeId) {
      try {
        const {
          data: {
            name,
            department,
            province,
            country: { code: countryCode },
            location: { lat, lng },
          },
        } = await shipper.getPlaceDetails(placeId);

        const countryId = countries.find(co => co.code === countryCode)?.id;

        if (flag === 'origen') {
          setFrom(name);
          setFromDepartment(department);
          setFromProvince(province);
          setFromCountryId(countryId);
          setFromGeoCodeStr(`${lat},${lng}`);
          setFromMarkerPosition([lat, lng]);
        }

        if (flag === 'destino') {
          setTo(name);
          setToDepartment(department);
          setToProvince(province);
          setToCountryId(countryId);
          setToGeoCodeStr(`${lat},${lng}`);
          setToMarkerPosition([lat, lng]);
        }
      } catch (error) {
        setERRORMsg('Error al buscar la ciudad, intentá de nuevo mas tarde.');
      }
    }
  };

  const getDistance = async () => {
    try {
      const { data } = await shipper.getCityDistances(fromGeoCodeStr, toGeoCodeStr);
      const distanceOriginal = parseInt((Number(data.value) / 1000).toFixed(), 10);

      const distancePlusFrom = parseInt(plusKmFrom, 10) ? parseInt(plusKmFrom, 10) : 0;
      const distancePlusTo = parseInt(plusKmTo, 10) ? parseInt(plusKmTo, 10) : 0;
      const dist = distanceOriginal + distancePlusFrom + distancePlusTo;

      setDistance(parseInt(dist, 10));
    } catch (error) {
      console.error(error);
    }
  };

  // Array de fechas para mostrar al usuario
  const buildDateArr = days => {
    const dateArr = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; days >= i; i++) {
      if (i === 0) {
        dateArr.push(
          `${moment()
            .locale('es')
            .format('DD-MMM-YYYY')} ${TODAY_STRING}`
        );
      } else {
        dateArr.push(
          moment(new Date())
            .add(i, 'days')
            .locale('es')
            .format('DD-MMM-YYYY')
        );
      }
    }
    return dateArr;
  };

  const setFlatImageFile = file => {
    const newFile = new File([file], `imagenPlano_${_id}_${new Date().getTime()}.jpg`, {
      type: 'image/jpeg',
    });

    setFlatImage(newFile);
  };

  // eslint-disable-next-line no-shadow
  const uploadFlatImage = async flatImage => {
    const formData = new FormData();
    formData.append('file', flatImage);

    const { data } = await generic.uploadFlatImage(formData);

    return data.result.files.file[0].name;
  };

  const upload = async () => {
    const loadDateAndTime = moment(
      `${loadDate.replace(TODAY_STRING)} ${hour}`,
      'DD-MMM-YYYY HH:mm'
    ).toISOString();

    try {
      // País Argentina, por default para la moneda.-
      const arCountryId = countries.find(co => co.code === 'AR')?.id;

      const load = {
        date: loadDateAndTime,
        status: 'close', // Por default cerrada, ya que entra por pre-cargas.-
        from,
        ...(fromAddress && { fromAddress }),
        fromDepartment,
        fromProvince,
        fromCountryId,
        fromGeoCodeStr,
        to,
        ...(toAddress && { toAddress }),
        toDepartment,
        toProvince,
        toCountryId,
        toGeoCodeStr,
        distance: `${distance.toString()} km`,
        shipperDetailId,
        origin: loadOrigin,
        productId: productTypeSelected._id,
        productQuantity: parseInt(productQuantity, 10),
        unitId: unitSelected._id,
        fareType,
        shipperFare: Number(manualFare),
        shipperFareCurrencyCountryId: arCountryId,
        requestedTrucks: parseInt(requestedTrucks, 10),
        publicComments,
        privateComments,
        ...(flatImage && { planImageName: await uploadFlatImage(flatImage) }),
        insured,
        insuredFare: 130000,
        handmade: false,
        duration: publicationTime,
      };

      const res = await shipper.addLoad(load);
      // const res = { status: 201 };

      if (res.status === 201) {
        setStepOne(false);
        setIsLoading(false);
        setUploadSuccess(true);
      }
    } catch (error) {
      if (error.response) {
        setIsLoading(false);
        const { data } = error.response;
        const msg = data.errors?.map(err => err.msg).join('. ') || data;
        setERRORMsg(`Error: ${msg}`);
      } else {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    if (resetFields) {
      setRenderFromMarker(false);
      setFromId('');
      setFromCity('');
      setFromAddress('');
      setFrom('');
      setFromDepartment('');
      setFromProvince('');
      setFromCountryId(undefined);
      setFromGeoCodeStr('');
      setFromMarkerPosition('');
      setToId('');
      setToCity('');
      setToAddress('');
      setTo('');
      setToDepartment('');
      setToProvince('');
      setToCountryId(undefined);
      setToGeoCodeStr('');
      setToMarkerPosition('');
      setRenderToMarker(false);
      setDistance(0);
      setPosition(initialPosition);
      setFare('');
      setFareType('');
      setPlusKmFrom('');
      setPlusKmTo('');
      setLoadTypeSelected('');
      setLoadDate('');
      setProductTypeSelected('');
      setUnitSelected('');
      setFlatImage('');
      setFlatImageUri('');
      setPrivateComments('');
      setPublicComments('');
      setLoadOrigin('');
      setRequestedTrucks('');
      setHour('');
      setProductQuantity('');
      setPublicationTime('');
      setTruckerSelectedList([]);
      setTrucker('');
    }
    setResetFields(false);
  }, [resetFields]);

  const stageChangeUpload = () => {
    const now = moment(new Date());
    if (loadDate && hour) {
      const loadDateAndTime = moment(
        `${loadDate.replace(TODAY_STRING)} ${hour}`,
        'DD-MMM-YYYY HH:mm'
      );
      if (
        loadTypeSelected !== '' &&
        loadDate !== '' &&
        publicationTime !== '' &&
        requestedTrucks !== '0' &&
        requestedTrucks !== '' &&
        productQuantity !== '0' &&
        productQuantity !== '' &&
        productTypeSelected !== '' &&
        unitSelected !== '' &&
        publicComments !== '' &&
        privateComments !== '' &&
        loadDateAndTime.isAfter(now)
      ) {
        setERRORMsg('');
        setIsLoading(true);
        upload();
      } else {
        setERRORMsg(
          loadDateAndTime.isBefore(now)
            ? 'La hora tiene que ser mayor a la actual'
            : ALL_FIELD_COMPLETED_ERR_MSG
        );
        setStepOne(false);
      }
    } else {
      setERRORMsg(ALL_FIELD_COMPLETED_ERR_MSG);
      setStepOne(false);
    }
  };

  useEffect(() => {
    if (flatImage) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFlatImageUri(reader.result);
      };
      reader.onerror = () => {
        console.error(reader.error);
      };
      reader.readAsDataURL(flatImage);
    }
  }, [flatImage, flatImageUri]);

  useEffect(() => {
    getCountries();
    getLoadTypes();
    getUnits();
    getShipperById(_id);
  }, []);

  async function setFareData(dist) {
    try {
      const { data: newFare } = await generic.getFare(dist);
      setFare(parseInt(newFare, 10));
      setManualFare(newFare.toFixed(2));
    } catch (err) {
      setERRORMsg('Error obteniendo la tarifa. Volvé a intentar en unos minutos');
    }
    if (loadTypeSelected.tipoCarga === 'Granel') {
      setFareType('TN');
      setInsured(true);
    } else {
      setFareType('viaje');
      setInsured(false);
    }
    setProductTypes(loadTypeSelected.tipoProducto);
    setProductTypeSelected('');
  }

  useEffect(() => {
    if (loadTypeSelected) {
      setFareData(distance);
    }
  }, [loadTypeSelected]);

  useEffect(() => {
    if (errorMsg) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [errorMsg]);

  useEffect(() => {
    if (errorMsg || stepOne || uploadSuccess) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [errorMsg, stepOne, uploadSuccess]);

  useEffect(() => {
    setERRORMsg('');
  }, [trucker, truckerSelectedList]);

  useEffect(() => {
    if (fromMarkerPosition) {
      setRenderFromMarker(true);
      setPosition(fromMarkerPosition);
    }
    if (toMarkerPosition) {
      setRenderToMarker(true);
      setPosition(toMarkerPosition);
    }
  }, [fromMarkerPosition, toMarkerPosition]);

  useEffect(() => {
    if (fromGeoCodeStr && toGeoCodeStr) {
      getDistance();
    }
  }, [fromGeoCodeStr, toGeoCodeStr, plusKmFrom, plusKmTo]);

  useEffect(() => {
    if (avtiveLoadsRedirect) {
      // eslint-disable-next-line react/prop-types
      props.history.push('/point/active-loads');
    }
  }, [avtiveLoadsRedirect]);

  // Hacer validaciones de cada campo
  const fieldValidation = () => {
    return true;
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {/* Formulario de Alta para Rizobacter/Bioceres */}
      {isRizobacterPoint && <AddLoadForm countries={countries} shipperDetailId={shipperDetailId} />}

      {/* Formulario de Alta para Virreyes */}
      {/* Se comenta hasta verificar si lo usan o no y de acuerdo a ello, adaptarlo */}
      {/* {isVireyesPoint && <VirreyesAddLoadForm user={user} />} */}

      {/** DEFAULT */}
      {/* {!isRizobacterPoint && !isVireyesPoint && ( */}
      {!isRizobacterPoint && (
        <CSS.AddLoadWrap>
          {errorMsg !== '' ? <p className="error-msg">{errorMsg}</p> : ''}

          <div className={stepOne ? 'sm-side-info side-info' : 'lg-side-info side-info'}>
            {!uploadSuccess && (
              <Map center={position} scrollWheelZoom={false} bounds={bounds}>
                <TileLayer
                  attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {renderFromMarker ? <Marker position={fromMarkerPosition} icon={startIcon} /> : ''}
                {renderToMarker ? <Marker position={toMarkerPosition} icon={endIcon} /> : ''}
              </Map>
            )}

            <CSS.LoadDetail>
              <h4>Resumen de tu carga</h4>
              <div className="from-wrapper">
                {fromCity && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      <b>Origen</b>
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{fromCity}</p>
                  </>
                )}
                {plusKmFrom && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Kms Adicionales
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{plusKmFrom}</p>
                  </>
                )}
                {fromAddress && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Dirección
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{fromAddress}</p>
                  </>
                )}
              </div>
              <div className="to-wrapper">
                {toCity && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      <b>Destino</b>
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{toCity}</p>
                  </>
                )}
                {plusKmTo && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Kms Adicionales
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{plusKmTo}</p>
                  </>
                )}
                {toAddress && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Dirección
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{toAddress}</p>
                  </>
                )}
              </div>
              <div className="distance-wrap" style={{ animation: `fadeIn 5s` }}>
                {distance >= 0 && (
                  <>
                    <p className="label">Distancia Total</p>
                    <p>{distance} kms</p>
                  </>
                )}
              </div>
              <div className="load-info">
                {loadTypeSelected && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Tipo de carga
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{loadTypeSelected.tipoCarga}</p>
                  </>
                )}
                {productTypeSelected && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Tipo de producto
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{productTypeSelected.label}</p>
                  </>
                )}
                {loadOrigin && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Origen de tu carga
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{loadOrigin}</p>
                  </>
                )}
              </div>
              <div className="trucks-info">
                {requestedTrucks && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Cantidad de camiones
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{requestedTrucks}</p>
                  </>
                )}
                {productQuantity && (
                  <>
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Cantidad de producto por camión
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>
                      {productQuantity} {unitSelected.label}
                    </p>
                  </>
                )}
              </div>
              <div className="last-info">
                {loadDate && (
                  <span className="item">
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Fecha de carga
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{loadDate}</p>
                  </span>
                )}
                {hour && (
                  <span className="item">
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Hora de carga
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>{hour}</p>
                  </span>
                )}
                {publicationTime === 0 && (
                  <span className="item">
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Duración de la publicación
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>Hasta la fecha y hora de carga</p>
                  </span>
                )}
                {publicationTime > 0 && (
                  <span className="item">
                    <p className="label" style={{ animation: `fadeIn 5s` }}>
                      Duración de la publicación
                    </p>
                    <p style={{ animation: `fadeIn 5s` }}>por {publicationTime} hs.</p>
                  </span>
                )}
                {fare && (
                  <>
                    <h1>${`${manualFare} / ${fareType}`}</h1>
                    {!uploadSuccess && (
                      <div className="sm-input-wrap fare-input">
                        <HumberInput
                          label="Ajustá tu tarifa"
                          value={manualFare}
                          min="0"
                          type="number"
                          onChange={setManualFare}
                          onBlur={fieldValidation}
                          id="manualFare"
                          htmlFor="manualFare"
                          errorMsg=""
                        />
                      </div>
                    )}
                  </>
                )}
                {!stepOne && (
                  <div className="btn-submit-wrap">
                    {!uploadSuccess && (
                      <div
                        role="button"
                        tabIndex={0}
                        className="btn-submit"
                        onClick={() => {
                          setStepOne(false);
                          stageChangeUpload();
                        }}
                      >
                        Subir carga
                      </div>
                    )}
                  </div>
                )}
              </div>
            </CSS.LoadDetail>
          </div>

          <div className="form">
            {stepOne ? (
              <div className="step-one-wrap">
                <h4 className="first">Origen</h4>
                <div className="humber-dropdown">
                  <label htmlFor="fromCity">
                    Ciudad *
                    <Async
                      id="fromCity"
                      className="dropdown"
                      defaultOptions
                      placeholder={fromCity}
                      loadOptions={originOptions}
                      onBlur={() => getPlaceDetails(fromId, 'origen')}
                      onChange={opt => {
                        setFromCity(opt.label.split(',')[0]);
                        setFromId(opt.value);
                      }}
                    />
                  </label>
                </div>

                <div className="xsm-input-wrap">
                  <HumberInput
                    label="Kms adicionales"
                    value={plusKmFrom}
                    type="number"
                    onChange={setPlusKmFrom}
                    onBlur={fieldValidation}
                    id="plusKmFrom"
                    htmlFor="plusKmFrom"
                    errorMsg=""
                  />
                </div>

                <div className="l-input-wrap">
                  <HumberInput
                    label="Dirección"
                    value={fromAddress}
                    type="text"
                    onChange={setFromAddress}
                    id="fromAddres"
                    htmlFor="fromAddres"
                    errorMsg=""
                  />
                </div>

                <h4>Destino</h4>
                <div className="humber-dropdown">
                  <label htmlFor="toCity">
                    Ciudad *
                    <Async
                      id="toCity"
                      className="dropdown"
                      defaultOptions
                      placeholder={toCity}
                      loadOptions={destinationOptions}
                      onBlur={() => getPlaceDetails(toId, 'destino')}
                      onChange={opt => {
                        setToCity(opt.label.split(',')[0]);
                        setToId(opt.value);
                      }}
                    />
                  </label>
                </div>

                {showAdditionalInfo && (
                  <>
                    <div className="xsm-input-wrap" style={{ animation: `fadeIn 2s` }}>
                      <HumberInput
                        label="Kms adicionales"
                        value={plusKmTo}
                        type="number"
                        onChange={setPlusKmTo}
                        id="plusKmTo"
                        htmlFor="plusKmTo"
                        errorMsg=""
                      />
                    </div>
                    <div className="l-input-wrap" style={{ animation: `fadeIn 2s` }}>
                      <HumberInput
                        label="Dirección"
                        value={toAddress}
                        type="text"
                        onChange={setToAddress}
                        id="toAddres"
                        htmlFor="toAddres"
                        errorMsg=""
                      />
                    </div>
                  </>
                )}

                <div
                  className="humber-link"
                  onClick={() => setShowAdditionalInfo(!showAdditionalInfo)}
                  role="button"
                  tabIndex={0}
                >
                  {!showAdditionalInfo
                    ? 'Agregar detalles del destino'
                    : 'Ocultar detalles del destino'}
                  <FontAwesomeIcon icon={faEdit} className="humber-link-icon" />
                </div>

                <div className="btn-wrapper">
                  {fromId && toId ? (
                    <button className="btn-enabled" onClick={() => setStepOne(false)}>
                      Siguiente
                    </button>
                  ) : (
                    <button className="btn-disabled">Siguiente</button>
                  )}
                  {fromId && toId && !uploadSuccess ? (
                    <div
                      role="button"
                      tabIndex={0}
                      className="mobile-next-button"
                      onClick={() => setStepOne(false)}
                    >
                      Siguiente
                    </div>
                  ) : (
                    <>{stepOne && <div className="mobile-next-button-disabled">Siguiente</div>}</>
                  )}
                </div>
              </div>
            ) : (
              <>
                {!uploadSuccess && (
                  <div className="step-two-wrap">
                    <CSS.LoadTypeWrap>
                      <h4 className="first">¿Qué tipo de carga vas a transportar? *</h4>
                      <SelectionButton
                        renderList={loadTypes.map(i => ({
                          _id: i.id,
                          renderValue: i.name,
                          tipoCarga: i.name,
                          // eslint-disable-next-line no-shadow
                          tipoProducto: i.products.map(({ id: _id, name: label }) => ({
                            _id,
                            label,
                          })),
                        }))}
                        renderValueChangeAction={setLoadTypeSelected}
                      />

                      <CSS.LoadTypeOptionsWrap>
                        {loadTypeSelected && (
                          <HumberDropdown
                            list={productTypes}
                            onChange={opt => setProductTypeSelected(opt)}
                            value={productTypeSelected}
                            label="¿Qué producto vas a cargar? *"
                            htmlFor="loadTypeSelect"
                            id="loadTypeSelect"
                            required
                          />
                        )}
                        {productTypes && loadTypeSelected.tipoCarga === 'Granel' && (
                          <CSS.OptionalInfo>
                            <CSS.ProductTypeQuickAccess>
                              <p>Acceso rápido:</p>
                              {productTypes.map(productType => {
                                if (
                                  productType.label === 'Soja' ||
                                  productType.label === 'Maíz' ||
                                  productType.label === 'Girasol' ||
                                  productType.label === 'Trigo'
                                ) {
                                  return (
                                    <button
                                      key={productType._id}
                                      tabIndex={0}
                                      onClick={() => setProductTypeSelected(productType)}
                                    >
                                      {productType.label}
                                    </button>
                                  );
                                }
                                return '';
                              })}
                            </CSS.ProductTypeQuickAccess>
                            <CSS.LoadOriginWrap>
                              <h3>¿De dónde vas a cargar?</h3>
                              <SelectionButton
                                renderList={loadOriginOption.map(i => ({
                                  renderValue: i.value,
                                  _id: i.id,
                                }))}
                                idChangeAction={setLoadOrigin}
                                dynamicClass="selection-button-horizontal-li"
                              />
                            </CSS.LoadOriginWrap>
                          </CSS.OptionalInfo>
                        )}
                      </CSS.LoadTypeOptionsWrap>
                    </CSS.LoadTypeWrap>

                    <h2>Configurá los camiones</h2>
                    <div className="sm-input-wrap">
                      <HumberInput
                        label="Cantidad de camiones *"
                        value={requestedTrucks}
                        min="0"
                        type="number"
                        onChange={setRequestedTrucks}
                        id="requestedTrucks"
                        htmlFor="requestedTrucks"
                        errorMsg=""
                        required
                      />
                    </div>
                    <div className="sm-input-wrap">
                      <HumberInput
                        label="Cant. de producto por camión *"
                        value={productQuantity}
                        min="0"
                        type="number"
                        onChange={setProductQuantity}
                        id="productQuantity"
                        htmlFor="productQuantity"
                        errorMsg=""
                        required
                      />
                    </div>
                    {loadTypeSelected && (
                      <div className="sm-input-wrap">
                        <HumberDropdown
                          list={units}
                          onChange={opt => setUnitSelected(opt)}
                          value={unitSelected}
                          label="Unidad de medida *"
                          htmlFor="unit"
                          id="unit"
                          required
                        />
                      </div>
                    )}

                    <div className="selection-btn-wrapper">
                      <h4>¿Cuándo vas a cargar? *</h4>
                      <SelectionButton
                        renderList={buildDateArr(3).map(i => ({
                          renderValue: i,
                          _id: i,
                        }))}
                        renderValueChangeActionItem={setLoadDate}
                      />
                    </div>

                    <div className="sm-input-wrap">
                      <h4>Hora de carga*</h4>
                      <HumberInput
                        label="Hora"
                        value={hour}
                        type="time"
                        onChange={setHour}
                        id="hour"
                        htmlFor="hour"
                        errorMsg=""
                      />
                    </div>

                    <h4>Información adicional de la carga</h4>
                    <div className="humber-input md-input-wrap">
                      <label htmlFor="publicComments">
                        Comentarios públicos *
                        <textarea
                          placeholder="Este comentario lo van a ver todos los interesados en la carga..."
                          value={publicComments}
                          id="publicComments"
                          className="form-control"
                          onChange={e => setPublicComments(e.target.value)}
                        />
                      </label>
                    </div>

                    <div className="humber-input md-input-wrap">
                      <label htmlFor="privateComments">
                        Comentarios privados *
                        <textarea
                          placeholder="Este comentario sólo lo verán los que hayan tomado la carga...."
                          value={privateComments}
                          id="privateComments"
                          className="form-control"
                          onChange={e => setPrivateComments(e.target.value)}
                        />
                      </label>
                    </div>

                    <div className="upload-image-wrapper">
                      <div className="flat-image-uri">
                        {flatImageUri ? (
                          <img src={flatImageUri} alt="Plano con dirección del campo" />
                        ) : (
                          <FontAwesomeIcon className="camera-icon" icon={faCamera} />
                        )}
                      </div>
                      <div htmlFor="uploadImage" className="btn-upload-wrapper">
                        <label htmlFor="uploadImg" className="btn-upload">
                          Subir plano
                          <input
                            id="uploadImg"
                            type="file"
                            style={{ display: 'none' }}
                            onChange={event => setFlatImageFile(event.target.files[0])}
                          />
                        </label>
                      </div>
                    </div>

                    <h4>Quiero que mi carga esté publicada: *</h4>
                    <SelectionButton
                      renderList={publicationTimeArr.map(i => ({
                        renderValue: i.value,
                        _id: i.id,
                      }))}
                      idChangeAction={setPublicationTime}
                    />

                    <CSS.LoadDetailMobile>
                      <h4>Resumen de tu carga</h4>
                      <small>{fromCity ? 'Desde' : ''}</small>
                      <p>{fromCity}</p>
                      <small>{toCity ? 'Hasta' : ''}</small>
                      <p>{toCity}</p>
                      <small>{distance ? 'Distancia' : ''}</small>
                      <p>{distance}</p>
                      <small>{loadTypeSelected ? 'Tipo de carga' : ''}</small>
                      <p>{loadTypeSelected.tipoCarga}</p>
                      <small>{requestedTrucks ? 'Cantidad de camiones' : ''}</small>
                      <p>{productTypeSelected.label}</p>
                      <p>{requestedTrucks}</p>
                      <small>{productTypeSelected ? 'Tipo de producto' : ''}</small>
                      <p>{productTypeSelected.label}</p>
                      <small>{loadOrigin ? 'Origen de tu carga' : ''}</small>
                      <p>{loadOrigin}</p>
                      <small>{loadDate ? 'Fecha de carga' : ''}</small>
                      <p>{loadDate}</p>
                      <small>{hour ? 'Hora' : ''}</small>
                      <p>{hour}</p>
                      <small>{loadDate ? 'Duración de publicación' : ''}</small>
                      {publicationTime === 0 && (
                        <p style={{ animation: `fadeIn 5s` }}>Hasta la fecha y hora de carga</p>
                      )}
                      {publicationTime > 0 && (
                        <p style={{ animation: `fadeIn 5s` }}>por {publicationTime} hs.</p>
                      )}
                      <div className="btn-submit-wrap">
                        {!uploadSuccess && (
                          <div
                            role="button"
                            tabIndex={0}
                            className="btn-submit"
                            onClick={() => {
                              setStepOne(false);
                              stageChangeUpload();
                            }}
                          >
                            Subir carga
                          </div>
                        )}
                      </div>
                    </CSS.LoadDetailMobile>
                  </div>
                )}
              </>
            )}
          </div>

          {uploadSuccess && (
            <div>
              <OptionsRedirect
                genMsj="¡Tu carga fue subida con éxito!"
                msjBtn1="Subir otra carga"
                msjBtn2="Ver mis cargas"
                action1={() => {
                  setUploadSuccess(false);
                  setStepOne(true);
                  setResetFields(true);
                }}
                action2={() => {
                  setActiveLoadsRedirect(true);
                  setResetFields(true);
                }}
              />
            </div>
          )}
        </CSS.AddLoadWrap>
      )}
    </>
  );
};

export default AddLoadView;
